export default "__VITE_PUBLIC_ASSET__52136348__"